/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

/**
 * Creates a stateful object Proxy, intended to be used as 1 component instance's props by a component manager.
 * By placing the $state here, we don't have to rename all component managers from .js to .svelte.js
 *
 * @example
 * const myProps = createProps({
 *     foo: 'bar'
 * });
 * mount(MyComponent, {
 *     target: document.body,
 *     props: myProps
 * });
 * myProps.foo = 'baz';
 * myProps.newThing = 0;
 * myProps.newThing += 1;
 *
 * Be careful never to destructure myProps, since you will lose reactivity.
 *
 * @param {Object} initial
 * @returns {Proxy<Object>}
 */
export function createProps(initial = {}) {
    const props = $state(initial);
    return props;
}
